import { types } from '@commercebear/portal-api';
import { writable } from 'svelte/store';
import {
  concat,
  curry,
  mergeLeft,
} from 'ramda';
import { unsubscriber } from '../store';

const {
  IN_PROGRESS,
  SUCCESS,
  FAILURE,
} = types.jobStatus;

const {
  COMPLETED,
  FAILED,
  CANCELLED,
} = types.taskStatus;

const mergeResults = curry((newer, current) => {
  if (!current.finished) {
    return {
      ...current,
      ...newer,
      result: {
        errors: concat(newer?.errors ?? [], current?.result?.errors ?? []),
        success: newer?.success,
        warnings: concat(newer?.warnings ?? [], current?.result?.warnings ?? []),
      },
      status: SUCCESS,
      finished: true,
    };
  }

  return { ...current, status: SUCCESS };
});

export default function jobStore(sse, job) {
  const { update, subscribe } = writable({ progress: 0, ...job });

  const progressStore = sse.progress(job.id);
  const resultPromise = sse.result(job.id);

  return {
    subscribe(callback) {
      const unsubscribe = unsubscriber([subscribe(callback)]);

      if (![SUCCESS, FAILURE, COMPLETED, FAILED, CANCELLED].includes(job.status)) {
        unsubscribe.add(progressStore.subscribe((storeVal) => update(mergeLeft({
          progress: storeVal.progress || job.progress,
          status: storeVal.status || job.status || IN_PROGRESS,
          message: storeVal.message || job.message,
        }))));
      }

      // TODO: This promise would be best cancellable... but it is not ¯\_(ツ)_/¯
      resultPromise
        .then((result) => update(mergeResults(result)))
        .catch((error) => update(mergeLeft({
          error, // TODO: Can remove this once all jobs have been converted to new system
          result: { errors: error?.errors ?? [{ message: error.message }] },
          status: FAILURE,
        })));

      return unsubscribe;
    },
    update,
  };
}
